import React from "react";
import { useNavigate, useRouteLoaderData } from "react-router-dom";
import LabeledEntry from "../../../helpers/LabeledEntry";
import { Button, Stack, styled } from "@mui/material";
import { testSessionLoader } from "../../../../loaders/helpers";
import useInfoSnackbar from "../../../../hooks/useInfoSnackbar";
import {
  announcementDelete,
  announcementSend,
  announcementTextLongDescription,
  announcementView,
} from "../../../../api/announcement";
import ConfirmationContainer from "../../../helpers/ConfirmationContainer";

const StyledEntryContainer = styled(Stack)`
  gap: 1em;
  width: 80%;
  padding: 2em 0 4em;
`;

const StyledButtonContainer = styled(Stack)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4em;
`;

const announcementLoader = async (params) => {
  await testSessionLoader(params);
  const announcementEntityId = params.params.id;
  const announcementRes = await announcementView(announcementEntityId);
  const announcement = announcementRes.data;
  const longDescriptionRes = await announcementTextLongDescription(
    announcement.announcementEntityId);
  const longDescription = longDescriptionRes.data;
  return { announcement, longDescription };
};

const Announcement = () => {
  const { announcement, longDescription } = useRouteLoaderData(
    "adminAnnouncement");
  const infoSnackbar = useInfoSnackbar();
  const navigate = useNavigate();

  const handleUpdateButtonClicked = () => navigate("update");

  const handleDeleteConfirmed = async () => {
    const res = await announcementDelete(announcement.announcementEntityId);
    if (res.code === "SUCCESS") {
      infoSnackbar.alertSuccess(res.message);
      navigate("../", { replace: true });
    } else {
      infoSnackbar.alertError(res.message);
    }
  };

  const handleSendConfirmed = async () => {
    const res = await announcementSend(announcement.announcementEntityId);
    if (res.code === "SUCCESS") {
      infoSnackbar.alertSuccess(res.message);
      navigate(-1);
    } else {
      infoSnackbar.alertError(res.message);
    }
  };

  const placeholder = "Not Specified";

  return (
    <>
      <StyledEntryContainer>
        <LabeledEntry
          label="Label"
          value={announcement.label}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Description"
          value={longDescription}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Create Date"
          value={announcement.createDate}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Last Modified"
          value={announcement.modifyDate}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Send Date"
          value={announcement.sendDate}
          placeholder={"Not Sent"}
        />
        <LabeledEntry
          label="Announcement ID"
          value={announcement.announcementEntityId}
          placeholder={placeholder}
        />
      </StyledEntryContainer>
      <StyledButtonContainer>
        <ConfirmationContainer
          dialogTitle="Confirm Announcement Send"
          dialogMessage="Are you sure that you want to send this announcement?"
          onConfirmed={handleSendConfirmed}
        >
          <Button
            variant="contained"
          >
            Send
          </Button>
        </ConfirmationContainer>
        <Button
          variant="contained"
          onClick={handleUpdateButtonClicked}
        >
          Update
        </Button>
        <ConfirmationContainer
          dialogTitle="Confirm Announcement Deletion"
          dialogMessage="Are you sure that you want to delete this announcement?"
          onConfirmed={handleDeleteConfirmed}
        >
          <Button
            variant="contained"
            color="error"
          >
            Delete
          </Button>
        </ConfirmationContainer>
      </StyledButtonContainer>
    </>
  );
};

export { announcementLoader };
export default Announcement;